module.exports = __webpack_public_path__ + "b86fd4963d6e1bba7bbf9ca456be7632.pdf";